import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlus = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	height: 12,
	viewBox: "0 0 12 12",
	width: 12,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m10.5 6.75h-3.75v3.75c0 .4125-.3375.75-.75.75s-.75-.3375-.75-.75v-3.75h-3.75c-.4125 0-.75-.3375-.75-.75s.3375-.75.75-.75h3.75v-3.75c0-.4125.3375-.75.75-.75s.75.3375.75.75v3.75h3.75c.4125 0 .75.3375.75.75s-.3375.75-.75.75z",
		fill: "#3c59f6"
	})
});
export default SvgPlus;
